import { Injectable } from "@angular/core";
import { isEmailValid } from "@obg/ngx.common";
import { AppError, AppErrorType } from "@obg/ngx.core";
import { Observable, throwError } from "rxjs";

import { LoginClient } from "./login.client";
import { LoginConfigService } from "./login.config";
import {
	ResetPasswordByEmailAndSecurityQuestionModel,
	ResetPasswordBySmsModel,
	ResetPasswordWithTokenModel,
} from "./login.model";

@Injectable({ providedIn: "root" })
export class LoginService {
	constructor(
		private client: LoginClient,
		private config: LoginConfigService
	) {}

	resetPasswordWithToken(model: ResetPasswordWithTokenModel): Observable<object> {
		return this.client.resetPasswordWithToken(model);
	}

	resetPasswordByEmail(email: string): Observable<object> {
		email = email.trim();
		if (isEmailValid(email)) {
			return this.client.resetPasswordByEmail(email);
		}

		return throwError(
			() =>
				({
					type: AppErrorType.UnhandledError,
					data: "invalid-email",
				}) as AppError
		);
	}

	resetPasswordBySms(model: ResetPasswordBySmsModel): Observable<object> {
		if (this.config.getResetPasswordBySmsEnabled()) {
			return this.client.resetPasswordBySms(model);
		}

		return throwError(
			() =>
				({
					type: AppErrorType.UnhandledError,
					data: "reset-password-by-sms-is-disabled",
				}) as AppError
		);
	}

	resetPasswordByEmailAndSecurityQuestion(payload: ResetPasswordByEmailAndSecurityQuestionModel): Observable<object> {
		const email = payload.email.trim();
		if (isEmailValid(email)) {
			return this.client.resetPasswordByEmailAndSecurityQuestion(email, payload.securityQuestion, payload.answer);
		}

		return throwError(
			() =>
				({
					type: AppErrorType.UnhandledError,
					data: "invalid-email",
				}) as AppError
		);
	}
}
